import { SortingColumn } from '@domain/sorting';
import { SortingTypeEnum } from '@shared';

export interface SortingModel {
	sortDirection: SortingTypeEnum;
	columns: SortingColumn[];
}
